export const getInventoryMasterList = state => {
    return state.list
}

export const getInventoryMasterAutocompleteList = state => {
    return state.autocomplete_list
}

export const getInventoryMasterDataProps = state => {
    return state.props
}

export const getToggleInventoryMasterLoadingState = (state, payload) => {
    return state.loading
}



// WEBPACK FOOTER //
// ./src/store/modules/inventoryMaster/getters.js